import { isDefined } from '@sgme/fp';
import type { ICellRendererParams } from 'ag-grid-community';
import classNames from 'classnames';
import { intlFormatDistance, isPast, parseISO } from 'date-fns';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { dateNow } from 'utils/core/now';

export const ProgressBarCellRenderer: FC<ICellRendererParams> = ({ value }) => {
  const dateValue = isDefined(value) ? parseISO(value) : undefined;
  const { locale } = useIntl();

  if (dateValue === undefined) {
    return null;
  }

  return (
    <span data-e2e="progress-bar-cell-renderer" className={classNames({ 'text-warning': isPast(dateValue) })}>
      {intlFormatDistance(dateValue, dateNow(), { locale })}
    </span>
  );
};
